import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { IMAGES } from "@/lib/assets";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SiteImagesContext = createContext({ img: (k) => IMAGES[k], list: [], refresh: () => {} });

const resolveUrl = (url) => {
  if (!url) return url;
  return url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
};

export const SiteImagesProvider = ({ children }) => {
  const [map, setMap] = useState(IMAGES);
  const [list, setList] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/site-images`);
      const next = { ...IMAGES };
      data.forEach((item) => { next[item.key] = resolveUrl(item.url); });
      setMap(next);
      setList(data.map((i) => ({ ...i, url: resolveUrl(i.url) })));
    } catch (e) {
      // keep defaults on failure
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const img = useCallback((key) => map[key] || IMAGES[key], [map]);

  return (
    <SiteImagesContext.Provider value={{ img, list, refresh }}>
      {children}
    </SiteImagesContext.Provider>
  );
};

export const useSiteImages = () => useContext(SiteImagesContext);
